import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthenticationProvider } from '../../context/AuthenticationContext';
import { ProjectProvider } from '../../project-details/context/ProjectContext';
import SaveReportDropdown from './SaveReportDropdown';
import ToastNotification from '../../components/toast/ToastNotification';

const $saveReportDropdowns: NodeListOf<HTMLElement> | null = document.querySelectorAll('[id=save-report-to-project]');
const $displaySaveReportDropdown = window._timken.displaySaveReportDropdown;

if ($saveReportDropdowns && $displaySaveReportDropdown) {
	$saveReportDropdowns.forEach(($saveReportDropdown) => {
		const $root = ReactDOM.createRoot($saveReportDropdown as HTMLElement);
		const isResultsReady = $saveReportDropdown.dataset.isResultsReady === 'true';
		const buttonStyle = $saveReportDropdown.dataset.buttonStyle ?? 'min';
		const partNumber = $saveReportDropdown.dataset.partNumber ?? '';
		const partImageUrls = $saveReportDropdown.dataset.gallery
			? JSON.parse($saveReportDropdown.dataset.gallery)
			: [];
		const partUrl = $saveReportDropdown.dataset.partUrl ?? '';
		const partType = $saveReportDropdown.dataset.partType ?? '';

		$root.render(
			<React.StrictMode>
				<AuthenticationProvider>
					<ProjectProvider>
						<SaveReportDropdown {...{
							isResultsReady,
							buttonStyle,
							partNumber,
							partUrl,
							partImageUrls,
							partType
						}} />
						<ToastNotification />
					</ProjectProvider>
				</AuthenticationProvider>
			</React.StrictMode>
		);
	});
}
